import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Button } from '@themesberg/react-bootstrap'
// import ClientFilter from '../../../components/ClientFilter'
// import PortalFilter from '../../../components/PortalFilter'
import Preloader from '../../../components/Preloader'
// import DemographicDetails from './components/DemographicDetails'
import LivePlayers from './components/LivePlayers'
// import TopPlayes from './components/TopPlayes'
import PlayerLiability from './components/PlayerLiability'
import KPISummary from './components/KPISummary'
// import KPIReport from './components/KPIReport'
import GameReport from './components/GameReport'
import useDashboard from './hooks/useDashboard'
import PlayerReport from './components/PlayerReport'
import UserStats from './components/UserStats'
import Header from './Header'
// import Highcharts from 'highcharts'
// import PieChart from "highcharts-react-official";
// const options = {
// 	chart: {
// 	  type: "pie"
// 	},
// 	// series: []
//   };
export default () => {
  const {
    selectedClient,
    setSelectedClient,
    selectedPortal,
    setSelectedPortal,
    reportsToShow,
    permissionKeys,
    loading,
    adminPermissions,
    elasticHealth,
    nonElasticReports
  } = useDashboard()

  return (
    <>
      {loading
        ? <Preloader />
        : (adminPermissions && permissionKeys.some(x => reportsToShow.indexOf(x) >= 0) &&
        (!elasticHealth || permissionKeys.some(x => nonElasticReports.indexOf(x) >= 0))
            ? (
              <>
                <Header />
                
                {/* <PieChart highcharts={Highcharts} options={options} series={livePlayerData?.deviceLoggedIn.filter(d => d.device_type !== null).map(d => d.count) || []} /> */}
                {permissionKeys.includes('LivePlayerReport') &&
                  <LivePlayers
                    selectedPortal={selectedPortal}
                    selectedClient={selectedClient}
                  />}

                {/* {permissionKeys.includes('DemographReport') &&
                  <Card className='overflow-hidden p-2 mb-5'>
                    <DemographicDetails
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>} */}

                {/* {permissionKeys.includes('PlayerManagementReport') &&
                  <Card className='p-2 mb-2'>
                    <TopPlayes
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>} */}

                {elasticHealth && permissionKeys.includes('PlayerLiabilityReport') &&
                  <Card className=' mb-5' style={{padding:"20px"}} >
                    <PlayerLiability
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>}

                  <Card className=' mb-5' style={{padding:"20px"}}>
                    <UserStats
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>
      
                {permissionKeys.includes('KpiSummaryReport') &&
                  <Card className=' mb-5' style={{padding:"20px"}}>
                    <KPISummary
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>}

                {/* {permissionKeys.includes('KpiReport') &&
                  <Card className='p-2 mb-5'>
                    <KPIReport
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>} */}

                {permissionKeys.includes('GameReport') &&
                  <Card className=' mb-5' style={{padding:"20px"}}>
                    <GameReport
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>}
                  <Card className=' mb-5' style={{padding:"20px"}}>
                    <PlayerReport
                      selectedPortal={selectedPortal}
                      selectedClient={selectedClient}
                    />
                  </Card>
              </>
              )
            : (
              <>
                <Card className='mb-2' style={{padding:"20px"}}>
                  <Row>
                    <Col>
                      <h3>Dashboard </h3>
                    </Col>
                  </Row>
                </Card>

                <Card style={{ height: '79vh' }}>
                  <img className='m-auto' src='/nodata2.png' alt='nodata' />
                </Card>
              </>
              ))}
    </>
  )
}
